import React from 'react'
import Loading from './../Loading'

export default props => <Loading />


// WEBPACK FOOTER //
// ./src/pages/Authorizing/Authorizing.js